const enumToOptions = (enums: any) => {
  return Object.keys(enums).map((id) => ({ id: enums[id], label: enums[id] }));
};

export default enumToOptions;
